import React from 'react';
import { Button, TopToolbar, SimpleShowLayout, List, Datagrid, TextField } from 'react-admin';
import Delete from '@material-ui/icons/Delete';
import DeleteWithCustomConfirmButton from 'ra-delete-with-custom-confirm-button';
import ErrorOutline from '@material-ui/icons/ErrorOutline';
import { EmptyList } from './empty.js'

const ListActions = (props) => {
    return (
        <TopToolbar style={{width: '100%', paddingRight: '15px'}}>
        <Button label='Close' variant="contained" color='primary' onClick={event => props.parent.setState({listing: false})} {...props} />
        </TopToolbar>
    )
}
export const UserReportsList = (props) => {
    function openSelectedReport(id, basePath, record) {
      // props.parent.handleRefreshReportByRecord(record);
      //window.location = `/#/adcost/${record.id}`;
      if (record) for (let i in record) {
        if (i=='_id') continue;
        for (let j in props.parent.state) {
          if (j==i) {
            let o = {};
            o[i] = record[i];
            props.parent.state[i] = record[i];
            props.parent.setState(o);
          }
        }
      }
    }
    const DeleteConfirmationContent = props => {
      return (
        <SimpleShowLayout {...props} >
          <TextField source='report_name' label='' style={{fontSize: 'larger'}}/>
        </SimpleShowLayout>
      );
    }
    return (
      <List {...props} basePath={(props.type=='adrequest'?'adcost':props.type)} actions={<ListActions parent={props.parent}/>} 
        exporter={false} resource={`user_reports/${props.type}`} filters={false} perPage={30} 
        empty={<EmptyList name='Reports' close={event => props.parent.setState({listing: false})}/>}
        bulkActionButtons={false}>
          <Datagrid rowClick={openSelectedReport}>
              <TextField source="report_name" label="Report Name" />
              <DeleteWithCustomConfirmButton
                title='Are you sure you want to delete this Report?'      // your custom title of delete confirm dialog
                content={DeleteConfirmationContent}  // your custom contents of delete confirm dialog
                label='Delete'                  // label of delete button (default: 'Delete')
                confirmColor='warning'          // color of delete button ('warning' or 'primary', default: 'warning')
                ConfirmIcon={Delete}            // icon of delete button (default: 'Delete')
                cancel='Cancel'                 // label of cancel button (default: 'Cancel')
                CancelIcon={ErrorOutline}       // icon of cancel button (default: 'ErrorOutline')
                undoable={true}                 // undoable (default: true)
              />
          </Datagrid>
      </List>
    )
  };
  export const ReportName = (props) => {
    return (
      <div style={{fontSize: 'smaller'}}>
        Report<span style={{width: '20px'}}>  </span>{(props.parent.state.report_name)?'  '+props.parent.state.report_name:''}
      </div>
    )
  }